import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Switch, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useParentPasscodeModalStore } from "./parentPasscodeModal/useParentPasscodeModalStore"
import { SelectRow } from "../../../components/selectRow/SelectRow"
import { SelectRowContainer } from "../../../components/selectRowContainer/SelectRowContainer"
import { useUserQuery } from "../../../networking/queries"
import { EnterParentPasscodeType } from "../../../types"

const ManagePasscodeSection = () => {
  const { onOpen: openManagePasscodeModal } = useParentPasscodeModalStore()
  const { user } = useUserQuery()
  const { t } = useTranslation()

  const isParentAppRequirement = user?.account_passcode !== null
  const isParentPanelRequirement = user?.parent_panel_passcode !== null
  const isParentAccessCodeEnabled =
    isParentAppRequirement || isParentPanelRequirement

  return (
    <div className="w-full flex flex-col gap-[10px] p-3 border border-borderPrimary rounded-md bg-backgroundPrimary">
      <div className="w-full flex flex-row gap-2 items-center justify-between">
        <Typography variant="bodySmallBold">
          {isParentAccessCodeEnabled
            ? t("PPC_ACCESS_CODE_ON")
            : t("PPC_ACCESS_CODE_OFF")}
        </Typography>
        <Switch
          checked={isParentAccessCodeEnabled}
          onChange={() =>
            openManagePasscodeModal(
              isParentAccessCodeEnabled
                ? EnterParentPasscodeType.TURN_OFF_CODE
                : undefined
            )
          }
          name="parentAccessCode"
          variant="small"
        />
      </div>
      {isParentAccessCodeEnabled ? (
        <div className="flex flex-col gap-2">
          <Typography variant="bodySmall">{t("PPC_REQUIRE_WHEN")}</Typography>
          <SelectRowContainer>
            <SelectRow
              hideBorder
              showBorderBottom
              style={{
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: 0,
              }}
            >
              {isParentAppRequirement && (
                <Typography variant="bodySmall">
                  {`• ${t("PPC_THE_PARENT_APP")}`}
                </Typography>
              )}
              {isParentPanelRequirement && (
                <Typography variant="bodySmall">
                  {`• ${t("PPC_THE_PARENT_PANEL")}`}
                </Typography>
              )}
            </SelectRow>
            <SelectRow
              onClick={() =>
                openManagePasscodeModal(
                  EnterParentPasscodeType.UPDATE_REQUIREMENT
                )
              }
              hideBorder
            >
              <Typography variant="bodySmall">
                {t("PPC_CHANGE_REQUIREMENT")}
              </Typography>
              <FontAwesomeIcon
                icon={faChevronRight}
                color={JoonUIColor.icon.neutral}
              />
            </SelectRow>
          </SelectRowContainer>
          <SelectRow
            onClick={() =>
              openManagePasscodeModal(EnterParentPasscodeType.UPDATE_CODE)
            }
          >
            <Typography variant="bodySmall">
              {t("PPC_CHANGE_ACCESS_CODE")}
            </Typography>

            <FontAwesomeIcon
              icon={faChevronRight}
              color={JoonUIColor.icon.neutral}
            />
          </SelectRow>
        </div>
      ) : (
        <Typography variant="bodySmall">{t("PPC_TURN_ON_DESC")}</Typography>
      )}
    </div>
  )
}

export default ManagePasscodeSection
